var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-section"},[_c('div',{staticClass:"button-row"},[_c('Rewind'),_c('PlayPause'),_c('FastForward')],1),_c('div',{staticClass:"button-row"},[_c('Prev'),_c('Home'),_c('Info')],1),_c('DirPad')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }